import { getSpotStatus, SpotStatus, type ISpot } from '@nova/core';

/**
 * Temporary FE adapter while the UI still speaks the legacy spot-status
 * vocabulary (OPEN/CLOSED/ASSIGNED/RESERVED). Collapses the FSM-driven
 * variants the backend now emits back to those values:
 *
 * - RESERVED_MANUAL / RESERVED_AUTOMATED -> RESERVED (same reserved visuals)
 * - LOCKED -> CLOSED. A LOCKED spot is the origin of an active move task,
 *   locked via `isActive = false` (see closeYardTaskMoveOriginSpot); the
 *   legacy `getSpotStatus` derivation returned CLOSED for it. The "assigned"
 *   appearance of such a spot is NOT its raw status — it comes from the
 *   move-task overlay in useYardSpotStatus (`isOriginOfActiveMoveTask`),
 *   which still upgrades the origin spot to assigned in overlay-aware
 *   consumers. Mapping to CLOSED keeps non-overlay consumers
 *   (useYardSpotSelect, useYard, the spot presenter) functionally equivalent.
 *
 * Delete once the UI handles RESERVED_MANUAL / RESERVED_AUTOMATED / LOCKED
 * directly (icons, colors, i18n, status strategies).
 */
const NEW_TO_LEGACY: Partial<Record<SpotStatus, SpotStatus>> = {
  [SpotStatus.RESERVED_MANUAL]: SpotStatus.RESERVED,
  [SpotStatus.RESERVED_AUTOMATED]: SpotStatus.RESERVED,
  [SpotStatus.LOCKED]: SpotStatus.CLOSED
};

export function toLegacySpotStatus(status: SpotStatus): SpotStatus {
  return NEW_TO_LEGACY[status] ?? status;
}

export function getLegacySpotStatus(spot: ISpot): SpotStatus {
  return toLegacySpotStatus(getSpotStatus(spot));
}
